import Vue from 'vue'
// eslint-disable-next-line import/no-named-as-default
import Fetch from '../api/fetch'

class Api {
  constructor(fetch) {
    this.fetch = fetch.instance
    this.store = fetch.store
  }

  get(...rest) {
    return this.fetch.get(...rest)
  }

  post(...rest) {
    return this.fetch.post(...rest)
  }

  // 公共请求
  getConfig() {
    return this.post('/api/v1/h5/adapter/frontconfig/share').then((data) => {
      this.store.commit('UP_SHARE_HOST', data.shareDomainUrl)
      return data
    })
  }
}

export default ({ store }) => {
  const fetch = new Fetch(store)
  const api = new Api(fetch)

  if (process.server) {
    api.getConfig()
  }

  if (!Vue.prototype.$api) {
    Vue.use({
      install(Vue) {
        Object.defineProperty(Vue.prototype, '$api', { get: () => api })
      }
    })
  }
}
